import {
  LessonI,
  PageI,
  ComponentI,
  isSupportedComponentType,
} from "../../../types";

/**
 * Returns true if the lesson has any component whose type is not supported by this build
 * (e.g. components created on stage when prod doesn't have that component type).
 */
export function lessonHasUnsupportedComponents(lesson: LessonI): boolean {
  return lesson.pages.some((page) =>
    page.components?.some((c) => !isSupportedComponentType(c.type)),
  );
}

/**
 * Returns a new lesson with unsupported components removed from every page.
 * Use when the user chooses "Delete these and save page".
 */
export function getLessonWithUnsupportedRemoved(lesson: LessonI): LessonI {
  return {
    ...lesson,
    pages: lesson.pages.map((page: PageI) => ({
      ...page,
      components: (page.components ?? []).filter((c: ComponentI) =>
        isSupportedComponentType(c.type),
      ),
    })),
  };
}
